import { BlokProps, withStoryblokEditable } from "@helpers/StoryblokHelpers"
import { ReviewCarouselSectionStoryblok } from "@storyblok-types"
import { ReviewCard, ReviewCarouselSection as ReviewCarouselSectionUI } from "@ui-library/review-carousel"

export const ReviewCarouselSection = ({ blok }: BlokProps<ReviewCarouselSectionStoryblok>) => {
  return (
    <ReviewCarouselSectionUI
      title={blok.title}
      background={blok.background}
      autoRotate={blok.auto_rotate}
      rotationInterval={blok.rotation_interval}
      disclaimer={blok.disclaimer}
      cards={(blok.reviews || []).map(review => (
        <ReviewCard
          key={review._uid}
          name={review.name}
          age={review.age}
          location={review.location}
          stars={review.stars ?? 5}
          title={review.title}
          quote={review.quote}
          readMoreText={review.read_more_text}
        />
      ))}
      {...withStoryblokEditable(blok)}
    />
  )
}

export default ReviewCarouselSection
